import React, { Component } from 'react';
import {createMarkup} from './Factory';

class Membership extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.handleName = this.handleName.bind(this);	
		this.handleSurname = this.handleSurname.bind(this);	
		this.handleStrasse = this.handleStrasse.bind(this);	
		this.handleHausnummer = this.handleHausnummer.bind(this);	
		this.handlePostleitzahl = this.handlePostleitzahl.bind(this);	
		this.handleOrt = this.handleOrt.bind(this);			
		this.handleLand = this.handleLand.bind(this);	
		this.handleEmail = this.handleEmail.bind(this);	
		this.handleTelephone = this.handleTelephone.bind(this);	
		this.handleType = this.handleType.bind(this);	
		this.handleCheck3 = this.handleCheck3.bind(this);	
		this.state = { 
						
						kontakt: {
								name:'',
								surname:'',
								strasse:'',
								hausnummer:'',
								postleitzahl:'',
								land:'',
								ort:'',
								email:'',
								telefone: '',
								type:''
						},
						submitted:false,
						sucess:false,
						fail:false,
						checkbox3:'',
						checkbox3Error:''
		}
	}
	handleCheck3(){
		this.setState({
			checkbox3:this.checkbox3.checked
		});
	}
	handleType(){
		let item = this.state.kontakt;
		item.type = this.type.value;
		this.setState({
			item
		});
	}
	handleTelephone(){
		let item = this.state.kontakt;
		item.telefone = this.telefone.value;
		this.setState({
			item
		});
	}
	handleEmail(){
		let item = this.state.kontakt;
		item.email = this.email.value;
		this.setState({
			item
		});
	}
	handleLand(){
		let item = this.state.kontakt;
		item.land = this.land.value;
		this.setState({
			item
		});
	}
	handleOrt(){
		let item = this.state.kontakt;
		item.ort = this.ort.value;
		this.setState({
			item
		});
	}
	handlePostleitzahl(){
		let item = this.state.kontakt;
		item.postleitzahl = this.postleitzahl.value;
		this.setState({
			item
		});
	}
	handleHausnummer(){
		let item = this.state.kontakt;
		item.hausnummer = this.hausnummer.value;
		this.setState({
			item
		});
	}
	handleStrasse(){
		let item = this.state.kontakt;
		item.strasse = this.strasse.value;
		this.setState({
			item
		});
	}
	handleSurname(){
		let item = this.state.kontakt;
		item.surname = this.surname.value;
		this.setState({
			item
		});
	}
	handleName(){
		let item = this.state.kontakt;
		item.name = this.name.value;
		this.setState({
			item
		});
	}
	handleClick(){
		this.props.handleClick();		
		this.setState({
			submitted:false,
			sucess:false
		});
	}
	handleSubmit(e){
		e.preventDefault();
		let dis = this;
		
		if(this.state.kontakt.name===''){
			this.name.focus(); 
			return false;
		}
		if(this.state.kontakt.surname===''){
			this.surname.focus(); 
			return false;
		}
		if(this.state.kontakt.strasse===''){
			this.strasse.focus(); 
			return false;
		}
		if(this.state.kontakt.hausnummer===''){
			this.hausnummer.focus(); 
			return false;
		}
		if(this.state.kontakt.postleitzahl===''){
			this.postleitzahl.focus(); 
			return false;
		}
		if(this.state.kontakt.ort===''){
			this.ort.focus(); 
			return false;
		}
		if(this.state.kontakt.land===''){
			this.land.focus(); 
			return false;
		}
		if(this.state.kontakt.email===''){
			this.email.focus(); 
			return false;
		}
		if(this.state.kontakt.type===''){
			this.email.focus(); 
			return false;
		}
		if(this.state.checkbox3==='' || !this.state.checkbox3){
			this.setState({
				checkbox3Error:'formError'
			})	
			return false;
		}	
		{			
			
			let kontakt = JSON.stringify(this.state.kontakt);
			let xhttp = new XMLHttpRequest();
			xhttp.open("POST", document.ajaxPath, true);
			xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhttp.send("action=membership_form_data&kontakt="+kontakt+"&lang="+document.language);
			xhttp.onreadystatechange = function() {
			  if (this.readyState === 4 && this.status === 200) {
				document.getElementById("myForm").reset();
				if(this.responseText==="Success"){
					dis.setState({
						submitted:true,
						sucess:true,
						checkbox3Error:''
					});
				}else{ 
					dis.setState({
						submitted:true,
						fail:true,
						checkbox3Error:''
					});
				}				
			  }
			};
		}	
	}
	
	render() {				
	   const {
			status,sucess_headline,sucess_text,error_headline,error_text,
			mitgliedschaften_title,mitgliedschaften_subtitle,mitgliedschaften_price
			
	   }  = this.props;	
	   const { 
				label_vorname,label_nachname,label_telefonnummer,label_email,label_strasse,label_hausnummer,
				label_postleitzahl,label_ort,label_land,label_anmelden,label_conclude,
				label_membership,label_membership_text,label_membership_type,label_required,label_obligatory
			 } = this.props.staticData;
	   return (
			<div className={`fixed-overlay ${status} `}>
				<div className="overlay-wrapper">
					<i onClick={this.handleClick} className="close-overlay icon-close"></i>
					{
					(!this.state.submitted) ?
						<form id="myForm" className="clearfix" onSubmit={this.handleSubmit} >
							<h1 className="overlay-title">{label_membership}</h1>
							<div className="overlay-subtitle md-txt">
								{label_membership_text}
							</div>
							<label className="margin-top-30" htmlFor="name">{label_vorname}*</label>
							<input id="name" type="text" ref={(input) => { this.name = input; }} onChange={this.handleName}/>
							<label htmlFor="vorname">{label_nachname}*</label>
							<input id="vorname" type="text" ref={(input) => { this.surname = input; }} onChange={this.handleSurname}/>
							<label htmlFor="strasse">{label_strasse}*</label>
							<input id="strasse" type="text" ref={(input) => { this.strasse = input; }} onChange={this.handleStrasse} />
							<label htmlFor="hausnummer">{label_hausnummer}*</label>
							<input id="hausnummer" type="text" ref={(input) => { this.hausnummer = input; }} onChange={this.handleHausnummer} />
							<label htmlFor="postleitzahl">{label_postleitzahl}*</label>
							<input id="postleitzahl" type="text" ref={(input) => { this.postleitzahl = input; }} onChange={this.handlePostleitzahl} />
							<label htmlFor="ort">{label_ort}*</label>
							<input id="ort" type="text" ref={(input) => { this.ort = input; }} onChange={this.handleOrt} />							
							<label htmlFor="land">{label_land}*</label>
							<input id="land" type="text" ref={(input) => { this.land = input; }} onChange={this.handleLand} />							
							<label htmlFor="email">{label_email}*</label>
							<input id="email" type="email" ref={(input) => { this.email = input; }} onChange={this.handleEmail}  />
							<label htmlFor="tel">{label_telefonnummer}</label>
							<input id="tel" type="tel" ref={(input) => { this.telefone = input; }} onChange={this.handleTelephone}/>
							<label htmlFor="desc">{label_membership_type}*</label>
							<select id="desc" ref={(input) => { this.type = input; }} onChange={this.handleType} rows="4">
								<option value=""></option>
								{
									mitgliedschaften_title.map( (data,i)=>(
										<option key={i} value={`${data} ${mitgliedschaften_subtitle[i]} ${mitgliedschaften_price[i]}`}>
											{`${data} ${mitgliedschaften_subtitle[i]} ${mitgliedschaften_price[i]}`}
										</option>
									))
									
									
								}
							</select>
							<label className="">*{label_required}</label>
							<div className={`formcheck ${this.state.checkbox3Error}`}>
								<div className="newsletter">
									<div className="newsletter-options">
										<div className="checkgroup">
											<input value="1" onChange={this.handleCheck3} ref={(input) => { this.checkbox3 = input; }} aria-label={label_obligatory} type="checkbox" id="newsletter-option3" />
											<label className="obligatory" htmlFor="newsletter-option3"></label>
											<span dangerouslySetInnerHTML={createMarkup(label_obligatory)}></span>
										</div>
									</div>
								</div>
							</div>
							<div className="clearfix"></div>
							<input type="submit" className="btn dark-btn pull-right" value={label_anmelden} />
						</form>
					: 	(this.state.sucess) ?
						<div>
							<h1 className="overlay-title">{sucess_headline}</h1>
							<p className="margin-top-30">{sucess_text}</p>
							<input type="button" className="btn dark-btn pull-right" value={label_conclude} onClick={this.handleClick} />
						</div>
						:
						<div>
							<h1 className="overlay-title">{error_headline}</h1>
							<p className="margin-top-30">{error_text}</p>
							<input type="button" className="btn dark-btn pull-right" value={label_conclude} onClick={this.handleClick} />
						</div>
					}	
				</div>
			</div>
		)
	   
	}
}
export default Membership;


// WEBPACK FOOTER //
// ./src/components/Membership.js